import { s__, __ } from '~/locale';
import { ACCESS_LEVEL_MAINTAINER_STRING } from '~/access_level/constants';
import { DUO_LICENSED_FEATURE } from '../constants';
import getAiCatalogProjects from '../graphql/queries/ai_catalog_projects.query.graphql';
import getAvailableProjects from '../graphql/queries/ai_catalog_available_projects.query.graphql';
import SingleSelectDropdown from '/builds/gitlab/gitlab-ee/ee/app/assets/javascripts/ai/catalog/components/single_select_dropdown.vue?vue3';
export default {
    name: 'FormProjectDropdown',
    components: {
        SingleSelectDropdown
    },
    props: {
        id: {
            type: String,
            required: false,
            default: null
        },
        value: {
            type: String,
            required: false,
            default: null
        },
        isValid: {
            type: Boolean,
            required: false,
            default: true
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        },
        itemId: {
            type: String,
            required: false,
            default: null
        }
    },
    emits: [
        'error',
        'input',
        'select'
    ],
    computed: {
        isFilteringEnabledProjects () {
            return Boolean(this.itemId);
        },
        query () {
            if (this.isFilteringEnabledProjects) return getAvailableProjects;
            return getAiCatalogProjects;
        },
        queryVariables () {
            const baseVariables = {
                minAccessLevel: ACCESS_LEVEL_MAINTAINER_STRING,
                sort: 'similarity',
                searchNamespaces: true,
                duoLicensedFeature: DUO_LICENSED_FEATURE
            };
            if (this.isFilteringEnabledProjects) {
                return {
                    ...baseVariables,
                    itemId: this.itemId
                };
            }
            return baseVariables;
        }
    },
    methods: {
        itemAlreadyEnabledFn (item) {
            return Boolean(item?.aiCatalogItemConsumerForItem?.enabled);
        },
        itemTextFn (item) {
            return item?.nameWithNamespace;
        },
        itemLabelFn (item) {
            return item?.name;
        },
        itemSubLabelFn (item) {
            return item?.nameWithNamespace;
        },
        itemDisabledFn (item) {
            return this.itemAlreadyEnabledFn(item);
        },
        itemTrailingLabelFn (item) {
            return this.itemAlreadyEnabledFn(item) ? s__('AICatalog|Already enabled') : null;
        },
        onInput (item) {
            // `input` stays the ID so v-model consumers keep working; `select` carries the
            // full project for consumers that need other fields (e.g. webPath).
            this.$emit('input', item.id);
            this.$emit('select', item);
        },
        onError () {
            this.$emit('error', __('Failed to load projects'));
        }
    }
};
